<template>
  <canvas height="16" />
</template>

<script>
export default {
  name: 'Chart',
  props: {
    value: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: '#4C959A'
    }
  },
  watch: {
    value() {
      this.draw()
    },
    color() {
      this.draw()
    }
  },
  mounted() {
    this.ctx = this.$el.getContext('2d')
    this.draw()
  },
  methods: {
    draw() {
      this.$el.width = this.value
      this.ctx.fillStyle = this.color
      this.ctx.fillRect(0, 0, this.value, 16)
    }
  },
}
</script>
